export type BatchItemsRequest<T> = {
  Items: T[]
  batchSize: number
}

export const batch = <T>({ Items, batchSize }: BatchItemsRequest<T>) => {
  /** we are choosing not to mutate Items */
  const itemsLength = Items.length
  let iteration = 0
  const res: T[][] = []
  do {
    const from = iteration * batchSize
    const to = (iteration + 1) * batchSize
    res.push(Items.slice(from, to))
    iteration++
  } while (iteration * batchSize < itemsLength)
  return res
}
